import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { UserManager } from '../../Services/UserManager/user-manager';
@Component({
  selector: 'app-revelation-today-email',
  templateUrl: './revelation-today-email.component.html',
  styleUrls: ['./revelation-today-email.component.css']
})
export class RevelationTodayEmailComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private um: UserManager
  ) { 

  }
  leaving = new Subject()
  profile;
  email
  id
  uid
  ngOnInit() {
    this.um.getProfileSubject()
    .takeUntil(this.leaving)
    .subscribe(profile => {
      
      this.profile = profile  
      if(this.profile?.uid){
        this.um.rtbypass(this.id)
      }
    })

  }

  ngOnDestroy() {
    this.leaving.next()
  }
  ngAfterViewInit() {
    this.id = this.route.snapshot.paramMap.get('id')
    this.email = this.route.snapshot.paramMap.get('email')
    this.uid = this.route.snapshot.paramMap.get('uid')
    if(+this.id > 25 || +this.id < 1){this.um.gotoHome(); return}

 
  }


  register = () => {
    this.um.revelationTodayEmailRegistration(+this.id, this.email, this.uid)
  }
  
}
